module.exports = __webpack_public_path__ + "static/media/glance3.e578d37b.jpeg";